import { useEffect } from 'react';

/** Full-viewport auth pages: dark body background, no layout bleed. */
const useAuthPageBackground = () => {
  useEffect(() => {
    document.body.classList.add('auth-page');
    return () => document.body.classList.remove('auth-page');
  }, []);
};

export default useAuthPageBackground;
